import { useCallback, useEffect, useState } from 'react';
import {
  FIXED_TERMINAL_STORAGE_KEY,
  clearFixedTerminalId,
  getFixedTerminalTarget,
  setFixedTerminalTarget,
  type FixedTerminalTarget,
} from './fixed-terminal.util';

type UseFixedTerminalResult = {
  fixedTerminalTarget: FixedTerminalTarget | null;
  setFixedTerminal: (target: FixedTerminalTarget) => void;
  clearFixedTerminal: () => void;
};

// Device-local terminal selection, synchronized between tabs on this device.
export function useFixedTerminal(): UseFixedTerminalResult {
  const [fixedTerminalTarget, setFixedTerminalTargetState] = useState<FixedTerminalTarget | null>(() => getFixedTerminalTarget());

  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event.key === FIXED_TERMINAL_STORAGE_KEY) {
        setFixedTerminalTargetState(getFixedTerminalTarget());
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const setFixedTerminal = useCallback((target: FixedTerminalTarget) => {
    setFixedTerminalTarget(target);
    setFixedTerminalTargetState(target);
  }, []);

  const clearFixedTerminal = useCallback(() => {
    clearFixedTerminalId();
    setFixedTerminalTargetState(null);
  }, []);

  return { fixedTerminalTarget, setFixedTerminal, clearFixedTerminal };
}